import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CustomizableAsset, Order, OrderLine, ReturnRequest } from '../../../common/generated-types';

@Component({
    selector: 'vsf-return-card',
    templateUrl: './return-card.component.html',
    styleUrls: ['./return-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})

export class ReturnCardComponent {
    @Input() returnRequest: ReturnRequest;
    @Input() order: Order;
    ngOnInit() {}

    trackReturnItem(index: number, item: { orderLineId: string; }): string {
        return item.orderLineId;
    }

    get items(): Array<{ orderLineId: string; name: string; quantity: number, customizations: CustomizableAsset[] | undefined }> {
        const lineMap = new Map(this.order.lines.map((l: OrderLine) => [l.id, l]));
        return (
            this.returnRequest?.items.map(item => {
                const line = lineMap.get(item.orderLineId);
                return {
                    orderLineId: item.orderLineId,
                    name: line?.productVariant.name ?? '',
                    quantity: item.quantity,
                    amount: line?.linePriceWithTax ?? 0,
                    customizations: line?.orderedCustomizableAssets ?? [],
                    optionName: line?.customizationOptionName ?? '',
                };
            }) ?? []
        );
    }
}
